"use client";
import { useEffect, useState } from "react";
import { MdLocalPhone } from "react-icons/md";
import { IoIosMail } from "react-icons/io";
import { FaFacebook, FaInstagram, FaTwitter,FaPinterest } from "react-icons/fa";
import Link from "next/link";

import { FaXTwitter } from "react-icons/fa6";

const Heading = () => {
  const defaultPhoneNumber = "+1 (888) 346 9886";
  const [phoneNumber, setPhoneNumber] = useState(defaultPhoneNumber);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tfn = urlParams.get("tfn");
    if (tfn) {
      setPhoneNumber(tfn);
    }
  }, []);

  return (
    <div className="bg-[#2B3252] display pt-2 pb-2 text-white">
      <div className="mx-auto max-w-7xl grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2">
        <div className="px-4 flex text-center justify-center sm:justify-center md:justify-center lg:justify-start md:text-start gap-2">
          <div className="pt-1 gap-2 flex">
            <Link
              target="blank"
              href="https://www.facebook.com/prestigeridelimo"
            >
              <div className="cursor-pointer">
                <FaFacebook />
              </div>
            </Link>
            <Link
              target="blank"
              href="https://www.instagram.com/prestigerideservices/"
            >
              <div className="cursor-pointer">
                <FaInstagram />
              </div>
            </Link>
            <Link target="blank" href="https://twitter.com/PrestigeRide">
              <div className="cursor-pointer">
                <FaXTwitter />
              </div>
            </Link>
            <Link target="blank" href="https://www.pinterest.com/prestigerideservices/">
              <div className="cursor-pointer">
              <FaPinterest />
              </div>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2">
          <a
            href={`tel:${phoneNumber}`}
            className="text-center flex justify-center sm:justify-start md:justify-start pl-6 lg:justify-end md:text-left"
          >
            <p className="font-bold flex items-center">
              <span className="text-xl md:mr-2">
                <MdLocalPhone />
              </span>
              <span>{phoneNumber}</span>
            </p>
          </a>

          <a
            href="mailto:contact@prestigeride.com"
            className="text-center flex justify-center sm:justify-end md:justify-end pr-6 lg:justify-end md:text-left"
          >
            <p className="font-bold gap-2 flex items-center">
              <span className="text-xl md:mr-0">
                <IoIosMail />
              </span>
              <span>contact@prestigeride.com</span>
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Heading;
